import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  summaryCard: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  alternativesRow: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr auto 1fr',
    gap: theme.spacing(1.5),
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      '& > svg': { display: 'none' },
    },
  },
  alternativeBadge: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1.25),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  alternativeBadgeRecommended: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    backgroundColor: theme.palette.primary.light,
  },
  badgeLabel: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    lineHeight: 1,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontWeight: 600,
  },
  badgeLetter: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  badgeLetterAuditor: {
    color: theme.palette.error.main,
  },
  badgeLetterUnit: {
    color: theme.palette.success.main,
  },
  badgeLetterRecommended: {
    color: theme.palette.primary.main,
  },
  badgeName: {
    fontSize: '0.75rem',
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
  arrowIcon: {
    color: theme.palette.text.secondary,
    alignSelf: 'center',
  },
  levelText: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  questionLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
  },
  questionText: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    lineHeight: 1.55,
  },
  countersRow: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  counterChip: {
    fontSize: '0.7rem',
    height: 22,
    fontWeight: 600,
    '& .MuiChip-icon': {
      marginLeft: 6,
    },
  },
  counterAdmissible: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    color: theme.palette.statusLabel.success.primary,
    '& .MuiChip-icon': { color: theme.palette.statusLabel.success.primary },
  },
  counterGroundless: {
    backgroundColor: theme.palette.statusLabel.error.secondary,
    color: theme.palette.statusLabel.error.primary,
    '& .MuiChip-icon': { color: theme.palette.statusLabel.error.primary },
  },
  strategyBox: {
    display: 'flex',
    gap: theme.spacing(1),
    padding: theme.spacing(1.25),
    backgroundColor: theme.palette.primary.light,
    borderRadius: theme.shape.borderRadius,
    alignItems: 'flex-start',
  },
  strategyIcon: {
    color: theme.palette.primary.main,
    flexShrink: 0,
    marginTop: 2,
  },
  strategyContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
  },
  strategyLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  strategyText: {
    fontSize: '0.82rem',
    color: theme.palette.text.primary,
    lineHeight: 1.55,
  },
  conclusionBox: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
  },
  conclusionLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.primary.main,
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  conclusionText: {
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    lineHeight: 1.6,
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    minHeight: 40,
    '& .MuiTab-root': {
      minHeight: 40,
      textTransform: 'none',
      fontSize: '0.85rem',
      fontWeight: 600,
    },
  },
  tabPanel: {
    paddingTop: theme.spacing(2),
  },
  documentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}))

export default useStyles
